
import { store } from "../../index";
import { IDictionary } from '../types/IDictionary';
import { IStore } from "../reducers/IStore";
import { ReducerActions } from "../enums/ReducerActions";
import AppSettingsApiClient from "../api/AppSettingsApiClient";

const IdentityServerUrl = 'IdentityServerUrl';
const WebsiteUrl = 'WebsiteUrl';


class ConfigurationService {
    
    public async getIdentityServerUrl(): Promise<string> {
        const config = await this.getConfiguration();
        if(config[IdentityServerUrl])
        {
            return config[IdentityServerUrl];
        }
        return '';
    }

    public async getWebsiteUrl(): Promise<string> {
        const config = await this.getConfiguration();
        if(config[WebsiteUrl])
        {
            return config[WebsiteUrl];
        }
        return '';
    }

    public async getConfiguration(): Promise<IDictionary<string>> {
        if(store !== undefined)
        {
            const currentState: IStore = store.getState();
            if(!Object.keys(currentState.configurations).length)
            {
                const configuration = await AppSettingsApiClient.getConfiguration();
                store.dispatch({ type: ReducerActions.UPDATE_CONFIGURATION, configurations: configuration })
                return configuration;
            }
            return currentState.configurations;
        }
        return {};
    }
}

export default ConfigurationService;